"use client";

import { useRouter } from "next/router";
import { type PlanVarSubdTo } from "~/types";

export const useRerouteIfAlreadyPremium = (mySub?: PlanVarSubdTo | null) => {
  const router = useRouter();
  if (mySub) void router.push("/my-account");
};
